import { defineComponent as _defineComponent } from 'vue'
import { ref, watch } from 'vue';
  import { Button } from '@/ui/components/Button';

  interface Props {
    modelValue?: string;
    disabled?: boolean;
    showDisabledLabel?: boolean;
  }

  
export default /*#__PURE__*/_defineComponent({
  __name: 'AiChatTextArea',
  props: {
    modelValue: { default: '' },
    disabled: { type: Boolean, default: false },
    showDisabledLabel: { type: Boolean, default: true }
  },
  emits: ['update:modelValue', 'send'],
  setup(__props: any, { emit }) {

const props = __props as { modelValue: string, disabled: boolean, showDisabledLabel: boolean };

  

  

  const textareaRef = ref<HTMLTextAreaElement>();
  const inputValue = ref(props.modelValue);

  watch(() => props.modelValue, newValue => {
    inputValue.value = newValue;
  });

  watch(inputValue, newValue => {
    emit('update:modelValue', newValue);
  });

  const handleSend = () => {
    if (inputValue.value.trim() && !props.disabled) {
      emit('send', inputValue.value);
      inputValue.value = '';
    }
  };

  const handleKeydown = (event: KeyboardEvent) => {
    if (event.key === 'Enter' && !event.shiftKey && !props.disabled) {
      event.preventDefault();
      handleSend();
    }
  };

return { __sfc: true,props, emit, textareaRef, inputValue, handleSend, handleKeydown, Button }
}

})